<template>
  <div class="statistics" v-loading="loading">
    <div class="statistics-container" v-if="hasData">
      <div class="task-banner statistics-banner"  @click="handleGoto('taskStatusOverview', 6, $event)" v-loading="projectOverviewDataloading">
        <div class="top">
          <p @click.stop="handleGoto('taskStatusOverview', 6, $event)">任务状态概览</p>
          <TitlePopover
            :content="describe1"
          ></TitlePopover>
        </div>
        <div class="task-banner-item-wrap">
          <div class="task-banner-item" @click.stop="handleGoto('taskStatusOverview', 6, $event)">
            <span>{{ projectOverviewData.total_number_of_tasks }}</span>
            <span>任务总数</span>
          </div>
          <div class="task-banner-item" @click.stop="handleGoto('taskStatusOverview', 3, $event)">
            <span>{{ projectOverviewData.completed_number_of_tasks }}</span>
            <span>已完成</span>
          </div>
          <div class="task-banner-item" @click.stop="handleGoto('taskStatusOverview', 2, $event)">
            <span>{{ projectOverviewData.undone_number_of_tasks }}</span>
            <span>未完成</span>
          </div>
          <div class="task-banner-item" @click.stop="handleGoto('taskStatusOverview', 5, $event)">
            <span>{{ projectOverviewData.overdue_number_of_tasks }}</span>
            <span>逾期</span>
          </div>
          <div class="task-banner-item" @click.stop="handleGoto('taskStatusOverview', 1, $event)">
            <span>{{ projectOverviewData.pending_number_of_tasks }}</span>
            <span>待认领</span>
          </div>
          <div class="task-banner-item mr" @click.stop="handleGoto('taskStatusOverview', 4, $event)">
            <span>{{ projectOverviewData.archived_number_of_tasks }}</span>
            <span>已归档</span>
          </div>
          <span class="line"></span>
          <Circular-progress :percents="getCount"></Circular-progress>
        </div>
        <!-- <ball :usingRate="getCount"></ball> -->
      </div>
      <div class="priority-banner statistics-banner" @click="handleGoto('taskPriorityRelease', 0, $event)" v-loading="sortRuleOverviewDataloaidng">
        <div class="top">
          <p @click.stop="handleGoto('taskPriorityRelease', 0, $event)">任务优先级分布</p>
          <TitlePopover
            :content="describe2"
          ></TitlePopover>
        </div>
        <ul class="priority-item-wrap">
          <li
            class="priority-item"
            v-for="item in sortRuleOverviewData"
            :key="item.sort_rule_id"
            :class="getPriorityClass(item.sort_rule.sort_name)"
            @click.stop="handleGoto('taskPriorityRelease', item.sort_rule_id, $event)"
          >
            <p class="percents">{{ item.poin }}%</p>
            <p class="priority-level">{{ item.sort_rule.sort_name }}</p>
            <el-progress
              :percentage="item.poin"
              :show-text="false"
            ></el-progress>
          </li>
        </ul>
        <!-- <ElProgress :stroke-width="16" type="circle" :percentage="item.poin" v-for="(item) in sortRuleOverviewData" :key="item.sort_rule_id" :color="getLevelStatus(item.sort_rule_id).color[1]">
          <div class="level-txt">
            <span>{{item.poin}}%</span>
            <span :style="{color:getLevelStatus(item.sort_rule_id).color[1]}">{{item.sort_rule.sort_name}}</span>
          </div>
        </ElProgress> -->
      </div>
      <div class="echarts-box">
        <div class="echarts-item statistics-banner" @click="handleGoto('taskExecutionStatus', 0, $event)">
          <div class="top">
            <p @click.stop="handleGoto('taskExecutionStatus', 0, $event)">任务执行情况</p>
            <TitlePopover
              :content="describe3"
            ></TitlePopover>
          </div>
          <!-- <div class="statis-box-title" @click.stop="toTaskExel">任务执行情况</div> -->
          <ToolFliter class="toolFliter" @selectTime="selectTime" />
          <BarMap :rangeTime="rangeTime" :projectId="projectId" @mapClick="toTaskExel" />
        </div>

        <div class="echarts-item statistics-banner" @click="handleGoto('projectProgressTrendChart', 0, $event)">
          <div class="top">
            <p @click.stop="handleGoto('projectProgressTrendChart', 0, $event)">项目进展走势图</p>
            <TitlePopover
              :content="describe4"
            ></TitlePopover>
          </div>
          <!-- <div class="statis-box-title">项目进展走势图</div> -->
          <Projectprogress :projectId="projectId" @mapClick="handleGotoPro" />
        </div>
      </div>
    </div>

    <nothing v-else>暂无任务数据</nothing>

  </div>
</template>

<script>
import TitlePopover from './components/popover.vue'
import ball from './ball'
import CircularProgress from '@/components/circularProgress'
import ElProgress from './progress'
import BarMap from './barMap'
import ToolFliter from './toolFliter'
import Projectprogress from './projectprogress'
import api from '@/services/api/statistics/statistics'
import dayjs from "dayjs";

export default {
  props: {
    projectId: {
      type: [Number, String],
      default: ''
    }
  },
  components: {
    TitlePopover,
    ball,
    CircularProgress,
    ElProgress,
    BarMap,
    ToolFliter,
    Projectprogress
  },
  computed: {
    getLevelStatus() {
      return (id) => {
        return this.levelList.find(res => res.sort_rule_id == id)
      }
    }
  },
  data() {
    return {
      hasData: false,
      loading: false,
      getCount: 0,
      describe1: '<p>·任务状态概览是查看任务总体状况和完成情况的统计报表。由任务总数、已完成、未完成、逾期、待认领、已归档任务数组成。</p> <p>·点击某一数字可查看详细任务信息，可以帮助你及时发现问题，管理进度。</p>',
      describe2: '<p>·任务优先级分布是查看项目中各项任务重要性的统计报表。由“最高、中等、普通、低”四个等级组成。</p> <p>·点击进入某一统计图可查看详细任务信息，可以帮助你及时发现问题，管理进度。</p>',
      describe3: '<p>·任务执行情况是查看各部门及部门内成员任务执行情况的统计报表，由部门任务执行情况统计图和成员执行情况报表组成。</p> <p>·统计图于每日1:00、14:00、23:00三个时间点进行刷新；表格为当前实时数据。</p> <p>·查看各成员任务执行信息，可以帮助你及时发现问题，管理进度。</p>',
      describe4: '<p>·项目进展走势图是项目完成前，帮助追踪项目中任务总量和任务完成情况的统计图。由任务总数、已完成、未完成、待认领、已归档任务数组成五条折线组成。</p> <p>·统计图于每日1:00、14:00、23:00三个时间点进行刷新；表格为当前实时数据。</p> <p>·查看项目内任务状态进展，可以帮助你及时发现问题，管理进度。</p>',
      levelList: [{
        sort_rule_id: 4,
        color: ['#FFD8DA', '#FFA1A4'],
      }, {
        sort_rule_id: 3,
        color: ['#FFE6A0', '#FFD88A'],
      }, {
        sort_rule_id: 2,
        color: ['#C3DEFF', '#8CBDFF'],
      }, {
        sort_rule_id: 1,
        color: ['#CDD0D4', '#B3B6BC'],
      }],
      rangeTime: [],
      projectOverviewDataloading: false,
      sortRuleOverviewDataloaidng: false,
      projectOverviewData: { // 数据概况

      },
      sortRuleOverviewData: [],//优先级分布
    }
  },
  watch: {
    projectId(val) {
      if (val) {
        this.init()
      }
    }
  },
  created() {
    this.loading = true
    this.init()
  },
  methods: {
    init() {
      this.getprojectOverview()
      this.getsortRuleOverview()
    },
    getprojectOverview() {
      this.projectOverviewDataloading = true
      const param = {
        project_id: this.projectId,
        task_stage_type: 6,
        task_filter_type: 1
      }
      api.projectOverview(param).then(res => {
        this.projectOverviewData = res

        // 判断是否有数据
        function areAllValuesZero(obj) {
          for (let key in obj) {
            if (obj.hasOwnProperty(key) && obj[key] !== 0) {
              return false;
            }
          }
          return true;
        }
        this.hasData = !areAllValuesZero(this.projectOverviewData)

        // 进度百分比=((1-未归档且未完成父任务进度统计数的求和) / 总父任务数(包括已归档任务)) x 100%
        // this.getCount = this.hasData ? Math.floor((this.projectOverviewData.completed_number_of_tasks + this.projectOverviewData.archived_number_of_tasks) / this.projectOverviewData.total_number_of_tasks * 100) : 0
        this.getCount = this.projectOverviewData.project_progress
        this.loading = false
        this.projectOverviewDataloading = false

      })
    },
    getsortRuleOverview() {
      this.sortRuleOverviewDataloaidng = true
      const param = {
        project_id: this.projectId,
        task_list_id: 0,
        task_filter_type: 1
      }
      api.sortRuleOverview(param).then(res => {
        this.sortRuleOverviewData = res
        this.getRuleAllCount()
        this.sortRuleOverviewDataloaidng = false
      })
    },
    getRuleAllCount() {
      let allCount = this.sortRuleOverviewData.reduce((result, pre) => {
        return result + pre.count * 1
      }, 0)
      this.sortRuleOverviewData.map((res, index) => {
        if (index === 3) {
          let p = 100 - this.sortRuleOverviewData.reduce((result, pre) => {
            return result + (pre.poin ? pre.poin * 1 : 0)
          }, 0)
          res.poin = p
        } else {
          let p = Math.floor((res.count / allCount) * 100)
          res.poin = p
        }
      })
    },
    getPriorityClass(type) {
      let className = ''
      switch (type) {
        case '最高':
          className = 'highest'
          break
        case '中等':
          className = 'medium'
          break
        case '普通':
          className = 'normal'
          break
        case '低':
          className = 'low'
          break
      }
      return className
    },
    selectTime(date) {
      this.rangeTime = [dayjs(new Date(date[0]).getTime()).format("YYYY-MM-DD"), dayjs(new Date(date[1]).getTime()).format("YYYY-MM-DD")]
    },
    toTaskExel() {
      this.$router.push(`./statisticsDetail?type=taskExecutionStatus&projectId=${ this.projectId }`)
    },
    handleGotoPro() {
      this.$router.push(`./statisticsDetail?type=projectProgressTrendChart&projectId=${ this.projectId }`)
    },
    // 去往对应的详情页
    handleGoto(type, val, event) {

      if (event.target.matches('.iconicon_document_details, .el-date-editor, .el-range-input') || event.target.nodeName === 'CANVAS') {
        // 点击的是tis的icon或者是数据表或者是日期组件
        return;
      }

      let _url = ''
      switch (type) {
        case 'taskStatusOverview':
          _url = `./statisticsDetail?type=${ type }&projectId=${ this.projectId }&taskStageType=${ val }`
          break
        case 'taskPriorityRelease':
          _url = `./statisticsDetail?type=${ type }&projectId=${ this.projectId }&sortRuleId=${ val }`
          break
        case 'taskExecutionStatus':
          _url = `./statisticsDetail?type=${ type }&projectId=${ this.projectId }`
          break
        case 'projectProgressTrendChart':
          _url = `./statisticsDetail?type=${ type }&projectId=${ this.projectId }`
          break
      }
      this.$router.push(_url)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/mixin.scss";
.statistics {
  height: 100%;
  padding-top: 16px;
  box-sizing: border-box;
  background: #F7F7F7;
  overflow: auto;
}
.statistics-container {
  width: 1198px;
  margin: 0 auto;
  .statistics-banner {
    background: #fff;
    width: 100%;
    padding: 16px 24px 0;
    box-sizing: border-box;
    border-radius: 4px;
    cursor: pointer;
    &:hover {
      box-shadow: 0px 2px 16px 0px rgba(32, 32, 32, .16);
    }
    &:active {
      box-shadow: 0px 2px 8px 0px rgba(32, 32, 32, .08);
    }
    .top {
      display: flex;
      align-items: center;
      cursor: pointer;
      p {
        font-size: 16px;
        line-height: 28px;
        margin-right: 5px;
        &:hover {
          color: #2682FF;
        }
        &:active {
          color: #2560B1;
        }
      }
      i {
        font-size: 13px;
        @include fontColorOpacity(.4);
      }
    }
  }
  .task-banner {
    width: 100%;
    height: 209px;
    .task-banner-item-wrap {
      width: 100%;
      height: 94px;
      display: flex;
      margin-top: 26px;
      .task-banner-item {
        width: 140px;
        height: 100%;
        border-radius: 8px;
        display: flex;
        flex-direction: column;
        padding: 18px 0 0 24px;
        box-sizing: border-box;
        border: 1px solid rgba(32, 32, 32, 0);
        margin-right: 16px;
        cursor: pointer;
        &:hover {
          border: 1px solid rgba(32, 32, 32, .6);
        }
        &:active {
          border: 1px solid rgba(32, 32, 32, 1);
        }
        &.mr {
          margin-right: 0;
        }
        span:first-child {
          font-size: 24px;
          line-height: 33px;
          font-weight: bold;
        }
        span:last-child {
          font-size: 14px;
          line-height: 20px;
          @include fontColorOpacity(.6);
          margin-top: 5px;
        }
      }

      .line {
        display: block;
        width: 1px;
        height: 94px;
        @include bgColorOpacity(.08);
        margin: 0 45px 0 2px;
      }
    }
  }
  .priority-banner {
    margin: 16px 0;
    padding-bottom: 30px;
    .priority-item-wrap {
      width: 100%;
      display: flex;
      justify-content: center;
      margin-top: 21px;
      li {
        width: 274px;
        height: 114px;
        border-radius: 8px;
        border: 1px solid rgba(32, 32, 32, 0);
        display: flex;
        flex-direction: column;
        margin-right: 18px;
        padding: 14px 0 0 24px;
        box-sizing: border-box;
        cursor: pointer;
        &:last-child {
          margin-right: 0;
        }
        &:hover {
          border: 1px solid rgba(32, 32, 32, .6);
        }
        &:active {
          border: 1px solid rgba(32, 32, 32, 1);
        }
        .percents {
          font-size: 24px;
          font-weight: bold;
          line-height: 34px;
        }
        .priority-level {
          font-size: 14px;
          line-height: 20px;
          margin: 4px 0 20px;
        }
        .el-progress {
          width: 220px;
          height: 6px;
          /deep/ .el-progress-bar__outer {
            @include bgColorOpacity(.08);
          }
        }
        &.highest {
          .priority-level {
            color: #FF3939;
          }
          /deep/ .el-progress-bar__inner {
            background: rgba(255, 57, 57, .8);
          }
        }
        &.medium {
          .priority-level {
            color: #FF8B23;
          }
          /deep/ .el-progress-bar__inner {
            background: rgba(255, 121, 17, .8);
          }
        }
        &.normal {
          .priority-level {
            color: #2682FF;
          }
          /deep/ .el-progress-bar__inner {
            background: rgba(38, 130, 255, .8);
          }
        }
        &.low {
          .priority-level {
            @include fontColorOpacity(.6);
          }
          /deep/ .el-progress-bar__inner {
            background: rgba(39,39,39,0.41);
          }
        }
      }
    }
  }
  .echarts-box {
    display: flex;
    justify-content: space-between;
    .echarts-item {
      width: 591px;
      height: 356px;
      position: relative;
      .top {
        p {
          line-height: 32px;
        }
      }
      /deep/ .toolFliter {
        position: absolute;
        right: 23px;
        top: 16px;
        z-index: 99;
      }
    }
  }
}
.project-progress {
  height: 384px;
}
.toolFliter {
  position: absolute;
  right: 16px;
  top: 16px;
  z-index: 99;
}
.statis-box {
  border-bottom: 1px solid #e7e8ed;
  background-color: #fff;
  // border-radius: 4px;
  position: relative;
  padding-top: 8px;
  box-sizing: border-box;
}
.level {
  height: 323px;
  width: 50%;
  // margin-right: 12px;
}
.level-map {
  width: 50%;
  height: 323px;
  position: relative;
}
.level-box {
  display: flex;
  justify-content: space-between;
}
.level-txt {
  display: flex;
  flex-direction: column;
  justify-content: center;
  span:first-child {
    font-size: 28px;
    font-weight: bold;
  }
  span:last-child {
    font-size: 12px;
    margin-top: 10px;
  }
}
.statis-box-title {
  font-size: 14px;
  position: absolute;
  font-weight: bold;
  top: 16px;
  left: 16px;
  z-index: 999;
  &:hover {
    cursor: pointer;
  }
}
</style>
